import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

/**
 * 顧客頭像：圖片載入失敗或沒有頭像時，一律顯示我們的預設樣式
 *（玫瑰色漸層圓 + 姓名第一個字，跟顧客列表卡片同一套）。
 *
 * 為什麼一定要接 onError：
 * LINE 客人的頭像是 LINE 給的外部網址（profile.line-scdn.net），
 * 客人在 LINE 換了大頭貼、或網址過期後，舊網址就會 404 ——
 * 我們這邊資料看起來「有頭像」，畫面上卻是一張破圖加 alt 文字。
 * 單靠「有沒有網址」判斷擋不住，只能在載入失敗當下換成預設。
 *
 * size：直徑（px）；mobileSize：≤640px 時的直徑（可省略）
 */

const Circle = styled.div`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f7;
  ${(p) => (p.$bordered ? 'border: 1px solid #ececf0;' : '')}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgb(229, 151, 170), #c4596f);
    color: #fff;
    font-weight: 600;
    font-size: ${(p) => Math.round(p.$size * 0.4)}px;
    line-height: 1;
    user-select: none;
  }

  ${(p) =>
    p.$mobileSize
      ? `@media (max-width: 640px) {
          width: ${p.$mobileSize}px;
          height: ${p.$mobileSize}px;
          .avatar-placeholder { font-size: ${Math.round(p.$mobileSize * 0.4)}px; }
        }`
      : ''}
`

export const avatarInitial = (name) => {
  const text = String(name || '').trim()
  // Array.from 才不會把表情符號之類的雙字元切壞
  return text ? Array.from(text)[0].toUpperCase() : '客'
}

const CustomerAvatar = ({
  src,
  name,
  size = 48,
  mobileSize,
  bordered = false,
  className,
  style
}) => {
  const [failed, setFailed] = useState(false)

  // 換了顧客（或頭像網址變了）就重新試一次
  useEffect(() => {
    setFailed(false)
  }, [src])

  return (
    <Circle
      $size={size}
      $mobileSize={mobileSize}
      $bordered={bordered}
      className={className}
      style={style}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={name || '顧客頭像'}
          referrerPolicy='no-referrer'
          onError={() => setFailed(true)}
        />
      ) : (
        <div className='avatar-placeholder' aria-label={name || '顧客'}>
          {avatarInitial(name)}
        </div>
      )}
    </Circle>
  )
}

export default CustomerAvatar
